export default "__VITE_ASSET__C129v8yK__"